export const THEME = {
  colors: {
    secondary: "#32374E",
  },
  gradients: {
    background: {
      start: "#1F3756",
      end: "#141539",
    },
    material: {
      DEFAULT: {
        start: "#1F3756",
        end: "#1F3756",
      },
      ROCK: {
        start: "#DC2E4E",
        end: "#DD405D",
      },
      PAPER: {
        start: "#4865F4",
        end: "#5671F5",
      },
      SCISSOR: {
        start: "#EC9E0E",
        end: "#ECA922",
      },
      LIZARD: {
        start: "#834FE3",
        end: "#8C5DE5",
      },
      SPOCK: {
        start: "#40B9CE",
        end: "#52BED1",
      },
    },
  },
};
